export enum SourceType {
  AudioFile = 'audio_file',
  VideoFile = 'video_file',
  Podcast = 'podcast',
  AudioCall = 'audio_call',
  VoiceNote = 'voice_note',
  Webinar = 'webinar',
  YouTubeVideo = 'youtube_video',
  InstagramReel = 'instagram_reel',
  TikTok = 'tiktok',
  YouTubeShort = 'youtube_short',
  SalesDemo = 'sales_demo',
  MeetingVideo = 'meeting_video',
  File = 'file',
  Website = 'website',
}
